import { IconButton, Shadow, Text, HStack } from '@genial/components';
import React, { useCallback } from 'react';

import { LateralBar } from '../../../../../../components/LateralBar';
import { fundsComparatorProductsColors } from '../../constants';

namespace FundComparatorProductCardTypes {
  export interface Props {
    product: any;
    productIndex: number;
    maxCardWidth: number;
    onRemove: (productId: string) => void;
    isMobile?: boolean;
  }
}

export const FundComparatorProductCard: React.FC<FundComparatorProductCardTypes.Props> = ({
  product,
  productIndex,
  maxCardWidth,
  onRemove,
  isMobile,
}) => {
  const handleRemove = useCallback(() => {
    onRemove(product.id);
  }, [onRemove, product.id]);

  return (
    <Shadow
      level={1}
      flex={1}
      maxWidth={isMobile ? '100%' : maxCardWidth}
      minWidth={isMobile ? '100%' : maxCardWidth}
      paddingX="inset.xs"
      paddingY="inset.nano">
      <LateralBar barColor={fundsComparatorProductsColors[productIndex]} />
      <HStack alignItems="center" space="stack.nano" flex={1}>
        <Text flex={1}>{product.name}</Text>
        <IconButton
          testId="remove-product-button"
          icon="Trash"
          iconColor="feedback.error.default"
          onPress={handleRemove}
        />
      </HStack>
    </Shadow>
  );
};
